import { coerceNumberProperty } from '@angular/cdk/coercion';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {
  private readonly units = [
    'Bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB'
  ];

  transform(bytes: number, decimals: number = 2): string {
    bytes = coerceNumberProperty(bytes, NaN);
    if (Number.isNaN(bytes)) {
      return '';
    } else if (bytes === 0) {
      return '0 Bytes';
    } else {
      const base = 1024;
      const ind = Math.floor(Math.log(bytes) / Math.log(base));
      return (
        parseFloat((bytes / Math.pow(base, ind)).toFixed(decimals)) +
        ' ' +
        this.units[ind]
      );
    }
  }
}
